import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

/**
 * TheCore Studio — Card surface.
 * Soft warm shadow, generous radius. The base container for class rows,
 * panels, stats.
 */
export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, "style"> {
  children?: ReactNode;
  /** CSS padding value. @default 'var(--space-5)' */
  padding?: string;
  /** Adds hover lift + pointer. */
  interactive?: boolean;
  style?: CSSProperties;
}

export function Card({
  children,
  padding = "var(--space-5)",
  interactive = false,
  style = {},
  ...rest
}: CardProps) {
  return (
    <div
      style={{
        background: "var(--surface-card)",
        border: "1px solid var(--border-subtle)",
        borderRadius: "var(--radius-lg)",
        boxShadow: "var(--shadow-sm)",
        padding,
        transition:
          "transform var(--dur-base) var(--ease-out), box-shadow var(--dur-base) var(--ease-out)",
        cursor: interactive ? "pointer" : "default",
        ...style,
      }}
      onMouseEnter={
        interactive
          ? (e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "var(--shadow-md)";
            }
          : undefined
      }
      onMouseLeave={
        interactive
          ? (e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "var(--shadow-sm)";
            }
          : undefined
      }
      {...rest}
    >
      {children}
    </div>
  );
}
